const templateUrl = require('./payment-form.html');

module.exports = angular.module('msi.payments.form', [
  'ui.router',
  require('@ordergroove/brandy/src/app/core/constants'),
  require('./expiration-date')
]).name;

angular.module(module.exports)
  .component('ogPaymentForm', {
    templateUrl: templateUrl,
    controller: require('./payment-form.controller'),
    bindings: {
      model: '=ngModel',
      requiredFields: '<ogRequiredFields',
      disabledFields: '<ogDisabledFields',
      disabled: '<ogDisabled'
    }
  });
